const plt_getPathList = (path: string) => {
  // 先頭と末尾のスラッシュを削除
  const trimmedPath = path.replace(/^\/|\/$/g, ''); 
  // console.log("trimmedPath: "+ trimmedPath);

  // ルートより下のパスのリストを取得
  const pathParts = trimmedPath.length > 0 ? trimmedPath.split('/') : [];
  // console.log("pathParts: " + pathParts)

  // trimmedPath生成時に除外されたパス(先頭の/)を['/']としてpathPartsの先頭に追加
  const pathList = ['/'].concat(pathParts);

  return pathList;
}

export default plt_getPathList;